import React from "react";
import { Modal } from "react-bootstrap";
import { ComponentLoader } from "../../component/ComponentLoader";
import { STATUS } from "../../constant";
import HistoryAndCommentLoader from "../IssueHistoryAndComments/History";

export default function HistoryAndCommentModal(props) {
  const {
    show,
    closeModal,
    isHistoryLoading,
    toggleIssueHistory,
    animationEnded,
    history,
    comment,
    type
  } = props;

  return (
    <React.Fragment>
      <Modal
        show={show}
        dialogClassName=" history-update-modal"
        onHide={closeModal}
      >
        <Modal.Body className="pmg-body">
          <div className="history-activity issue-history-scroll-date">
            <div className="close-history">
              <div onClick={closeModal}>X</div>
            </div>
            <div className="history-activity-head">
              <ComponentLoader
                isLoading={isHistoryLoading === STATUS.LOADING}
              />
              {["comment", "history"].map((value, index) => (
                <h2
                  className={`ah-heading ${type === value && "active"}`}
                  onClick={e => {
                    toggleIssueHistory(e, value);
                  }}
                  key={`title-${index}`}
                >
                  {(value === "history" && "Updates") || "Comments"}
                </h2>
              ))}
            </div>
            <HistoryAndCommentLoader
              animationEnded={animationEnded}
              isLoading={isHistoryLoading}
              data={type === "history" ? history : comment}
            />
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
